import React, { useState } from "react";
import { css } from "@emotion/core";
import styled from "@emotion/styled";
import Div100vh from "react-div-100vh";
import { colors, mediaQueries } from "../../configs/_configSite";
import Bubble from "../../images/victor-over-triple/bubble-background.png";
import NextPageArrow from "../Navigation/NextPageArrow";
import VOTLogo from "../../images/victor-over-triple/VOTLogo.png";
import VideoFile from "../../videos/vot-section-2-bg.mp4";
import VideoPLayerFullScreen from "../VideoPlayers/VideoPlayerFullScreen";

// Components
const BoxText = styled.section`
  font-family: Assistant;
  font-size: 1rem;
`;

// DATE COMPONENT ---------------------------------------------

const ContainerDate = styled.section`
  position: absolute;
  z-index: 1;
  bottom: 5vh;
  right: 10vw;
  width: 400px;
  box-sizing: border-box;

  background: transparent;

  @media (max-width: ${mediaQueries.lg}px) {
    transform: scale(0.95);
    right: 5vw;
    bottom: 5vh;
  }

  @media (max-width: ${mediaQueries.md}px) {
    transform: scale(0.85);
    right: 5vw;
    bottom: 7rem;
  }

  @media (max-width: ${mediaQueries.xs}px) {
    transform: scale(0.9);
    display: none;
    width: 100%;
    margin: 0 auto;
    left: 0;
    right: 0;
  }
`;

const DateWrapper = styled.div`
  display: flex;
  position: relative;
  width: 100%;
  min-height: 150px;
  margin-bottom: 15px;
  box-sizing: border-box;

  background: white;

  @media (max-width: ${mediaQueries.xs}px) {
    &:nth-of-type(2) {
      display: none;
    }
  }
`;

const DateTitle = styled.p`
  font-family: Assistant;
  font-weight: bold;
  font-size: 1rem;
  margin-top: 0;
  margin-bottom: 15px;
`;

const DateLink = styled.a`
  position: absolute;
  bottom: 5px;
  right: 15px;
  font-family: Assistant;
  font-size: 0.8rem;
  color: ${colors.gold};
  text-decoration: none;
  float: right;
  transition: 0.2s;

  &:hover {
    opacity: 0.75;
  }
`;

const dates = [
  {
    month: "OCT",
    day: "01",
    year: "2022",
    title: "BreastCancer.org",
    text:
      "Triple Negative Breast Cancer.Triple-negative breast cancer is cancer that tests negative for estrogen receptors, progesterone receptors, and excess HER2 protein.",
    link: "https://www.breastcancer.org/symptoms/types/triple-negative#treat"
  }
];

// SECTION COMPONENT ---------------------------------------------

// Style
const Container = styled(Div100vh)`
  position: relative;
  height: 100vh;
  width: 100vw;
`;

const TabsStyled = styled.div(
  ({ selectedTab }) => css`
    position: absolute;
    width: 690px;
    height: 508.83px;
    left: 13.28vw;
    top: 104px;
    background-image: url(${Bubble});
    background-size: contain;
    background-repeat: no-repeat;
    position: absolute;
    z-index: 2;
    font-family: Assistant;
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    padding: 100px 105px;
    box-sizing: border-box;
    transform-origin: top left;

    @media (max-width: ${mediaQueries.lg}px) {
      transform: scale(0.8);
      left: 13vw;
      top: 32vh;
    }

    button {
      color: #ccc;
      font-size: 18px;
      text-transform: uppercase;
      background: none;
      border: none;
      outline: none;
      margin-right: 30px;
      padding: 0 0 0.8rem 0;
      border-bottom: 0.6rem solid transparent;
      transition: all 0.2s;
      cursor: pointer;
      &:hover {
        color: #000;
      }
      &:nth-child(${selectedTab}) {
        color: #000;
        border-color: #ff0000;
      }
    }
    p {
      font-family: Assistant;
      font-style: normal;
      font-weight: 300;
      font-size: 18px;
    }

    @media (max-width: ${mediaQueries.xs}px) {
      background-image: none;
      background-color: #fff;
      left: 0;
      right: 0;
      max-width: 100vw;
      transform: none;
      padding: 20px;
      height: 275px;
      bottom: 70px;
      top: auto;
      p {
        font-size: 12px;
      }
      button {
        font-size: 14px;
      }
    }
  `
);

const LogoStyled = styled.img(
  () => css`
    position: absolute;
    left: calc(75vw - 165px);
    top: 8vh;
    z-index: 2;
    position: absolute;
    width: 330px;
    height: 242px;
    @media (max-width: ${mediaQueries.lg}px) {
      transform: scale(0.8);
      left: calc(50vw - 165px);
    }
    @media (max-width: ${mediaQueries.xs}px) {
      transform: scale(0.3);
      transform-origin: bottom left;
      top: auto;
      bottom: 350px;
      left: 20px;
    }
  `
);

const tabs = [
  {
    title: "The Fight",
    content: (
      <>
        <p>
          We get it... It’s hard sometimes to feel and embrace the truth that we
          are valued and made to shine with eachother by using the gifts we have
          from a walk thats uniquely our own. We need to remember from where
          that vestige of glory comes, and come together whenever we see it
          fade.
        </p>
      </>
    )
  },
  {
    title: "The Call",
    content: (
      <>
        <p>
          We get it... It’s hard sometimes to feel and embrace the truth that we
          are valued and made to shine with eachother by using the gifts we have
          from a walk thats uniquely our own. We need to remember from where
          that vestige of glory comes, and come together whenever we see it
          fade.
        </p>
      </>
    )
  },
  {
    title: "The Goal",
    content: (
      <>
        <p>
          We get it... It’s hard sometimes to feel and embrace the truth that we
          are valued and made to shine with eachother by using the gifts we have
          from a walk thats uniquely our own. We need to remember from where
          that vestige of glory comes, and come together whenever we see it
          fade.
        </p>
      </>
    )
  }
];
export default () => {
  const [selectedTab, setSelectedTab] = useState(1);

  return (
    <Container>
      <TabsStyled selectedTab={selectedTab}>
        {tabs.map(({ title }, idx) => (
          <button type="button" onClick={() => setSelectedTab(idx + 1)}>
            {title}
          </button>
        ))}
        {tabs[selectedTab - 1].content}
      </TabsStyled>
      <LogoStyled src={VOTLogo} />
      <ContainerDate>
        {dates.map(item => (
          <DateWrapper>
            <div
              css={css`
                display: flex;
                flex-direction: column;
                font-family: Blinker;
                min-height: 100px;
                width: 120px;
                padding-top: 15px;
                text-align: center;
                background: black;
                color: white;
              `}
            >
              <span>{item.month}</span>
              <span
                css={css`
                  font-size: 2rem;
                `}
              >
                {item.day}
              </span>
              <span>{item.year}</span>
            </div>
            <div
              css={css`
                padding: 15px;
              `}
            >
              <DateTitle>{item.title}</DateTitle>
              <BoxText>{item.text}</BoxText>
              {item.link.length > 0 && (
                <DateLink href={item.link}>
                  go to website
                  <svg
                    css={css`
                      position: relative;
                      margin-left: 10px;
                      top: 5px;
                    `}
                    width="11"
                    height="18"
                    viewBox="0 0 11 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9.58578 7.58578C10.3668 8.36683 10.3668 9.63316 9.58579 10.4142L3.41422 16.5858C2.15429 17.8457 1.80289e-06 16.9534 1.543e-06 15.1716L-2.57375e-07 2.82843C-5.1727e-07 1.04662 2.15428 0.154283 3.41421 1.41421L9.58578 7.58578Z"
                      fill="#D7B401"
                    />
                  </svg>
                </DateLink>
              )}
            </div>
          </DateWrapper>
        ))}
      </ContainerDate>
      <NextPageArrow text="Product" />
      <VideoPLayerFullScreen video={VideoFile} />
    </Container>
  );
};
